import React from "react";

import { Box, Button, IconButton, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SortIcon from "@mui/icons-material/Sort";

import FormRow from "components/form/FormRow";
import TextInput from "components/form/input/TextInput";
import { useFieldValue } from "components/form/input/NestedField";
import DateInput from "components/form/input/DateInput";
import useNotification from "notification";

const dateToString = (date) => {
    const formatNde = (d) => (d < 10 ? "0" + d : d);

    let d = new Date(date);
    let dStr =
        d.getFullYear() +
        "-" +
        formatNde(d.getMonth() + 1) +
        "-" +
        formatNde(d.getDate()) +
        "T" +
        formatNde(d.getHours()) +
        ":" +
        formatNde(d.getMinutes());

    return dStr;
};

function CardIntervalo({
    intervalo,
    deleteIntervalo,
    updateInicio,
    updateFim,
    updateObs,
    showWarning,
    dataInicio,
    dataFinal,
}) {
    return (
        <FormRow
            sx={{
                justifyContent: "center",
                mb: 1,
                backgroundColor: "rgba(125,125,125,0.2)",
                p: 1,
                display: "flex",
            }}
        >
            <DateInput
                name="inicio"
                label="INÍCIO"
                value={intervalo?.inicio}
                onChange={(e) => {
                    updateInicio(e.target.value);
                }}
                showTime
                sx={{ maxWidth: 175 }}
                inputProps={{
                    style: { textTransform: "uppercase" },
                    min: dateToString(dataInicio),
                    max: dateToString(dataFinal),
                }}
            />
            <DateInput
                name="fim"
                label="FIM"
                value={intervalo?.fim}
                showTime
                sx={{ maxWidth: 175 }}
                inputProps={{
                    style: { textTransform: "uppercase" },
                    min: intervalo.inicio || dateToString(dataInicio),
                    max: dateToString(dataFinal),
                }}
                onChange={(e) => {
                    updateFim(e.target.value);
                }}
            />
            <TextInput
                name="obs"
                label="OBSERVAÇÃO"
                value={intervalo?.obs}
                onChange={(e) => {
                    updateObs(e.target.value);
                }}
                multiline
            />
            <IconButton aria-label="delete" onClick={deleteIntervalo}>
                <DeleteIcon />
            </IconButton>
        </FormRow>
    );
}

function TabelaIntervalos({ nome, rotulo, dataInicio, dataFinal }) {
    const [intervalosAdicionados, setIntervalosAdicionados] = useFieldValue(nome);

    const { showWarning } = useNotification();
    const [possiveisReunioes, setPossiveisReunioes] = useFieldValue("possiveisReunioes");

    const newIntervalo = () => {
        const formatNde = (d) => (d < 10 ? "0" + d : d);

        let d = new Date(dataInicio);
        let dStr = d.getFullYear() + "-" + formatNde(d.getMonth() + 1) + "-" + formatNde(d.getDate()) + "T00:00";
        if (possiveisReunioes?.length) {
            showWarning("Esta alteração limpou os horários gerados");
        }
        setPossiveisReunioes([]);
        setIntervalosAdicionados([{ inicio: dStr, fim: "", obs: "" }, ...intervalosAdicionados]);
    };

    const sortIntervalos = () => {
        setIntervalosAdicionados([
            ...intervalosAdicionados.sort((intervaloA, intervaloB) => {
                if (intervaloA.inicio > intervaloB.inicio) return 1;
                else if (intervaloA.inicio < intervaloB.inicio) return -1;
                else return 0;
            }),
        ]);
    };

    const deleteIntervalo = (index) => {
        let array = [...intervalosAdicionados];
        array.splice(index, 1);

        setPossiveisReunioes([]);
        setIntervalosAdicionados(array);
    };

    const updateInicio = (index, inicio) => {
        let array = [...intervalosAdicionados];
        array[index].inicio = inicio;

        setPossiveisReunioes([]);
        setIntervalosAdicionados(array);
    };

    const updateFim = (index, fim) => {
        let array = [...intervalosAdicionados];
        array[index].fim = fim;

        setPossiveisReunioes([]);
        setIntervalosAdicionados(array);
    };

    const updateObs = (index, obs) => {
        let array = [...intervalosAdicionados];
        array[index].obs = obs;
        setIntervalosAdicionados(array);
    };

    return (
        <Box sx={{ display: "flex", flexBasis: "100%", flexDirection: "column" }}>
            <FormRow
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "nowrap",
                }}
            >
                <Typography variant="h6">{rotulo}</Typography>
                <Box sx={{ display: "flex" }}>
                    <Button onClick={sortIntervalos} sx={{ m: 1, alignSelf: "flex-end" }} startIcon={<SortIcon />}>
                        Ordenar
                    </Button>
                    <Button onClick={newIntervalo} sx={{ m: 1, alignSelf: "flex-end" }} startIcon={<AddIcon />}>
                        Novo Intervalo
                    </Button>
                </Box>
            </FormRow>
            {intervalosAdicionados.length !== 0 ? (
                intervalosAdicionados.map((intervalo, index) => (
                    <CardIntervalo
                        key={index}
                        index={index}
                        intervalo={intervalo}
                        deleteIntervalo={() => deleteIntervalo(index)}
                        updateInicio={(inicio) => updateInicio(index, inicio)}
                        updateFim={(fim) => updateFim(index, fim)}
                        updateObs={(obs) => updateObs(index, obs)}
                        showWarning={showWarning}
                        dataInicio={dataInicio}
                        dataFinal={dataFinal}
                    />
                ))
            ) : (
                <FormRow sx={{ display: "flex", justifyContent: "center" }}>
                    <Typography sx={{ color: "text.disabled" }}>- NENHUM INTERVALO ADICIONADO -</Typography>
                </FormRow>
            )}
        </Box>
    );
}

export default TabelaIntervalos;
